import Pre from "./CodePre";
import Prism from "./CodePrism";

export default { Pre, Prism };
